// model
export * from "./core-wo-model";

export { SurveyModel as Model } from "../../packages/survey-core/src/survey";
